@if (!readonly) {
  <ng-content></ng-content>
}

@if (imageList.length === 0) {
  <p class="text">
    {{ 'common.messages.noImages' | translateSafe }}
  </p>
} @else {
  @for (image of imageList; track image; let i = $index) {
    <div class="image-container">
      <img [src]="bypassUrl(imagePath + image)"
           alt="image"
           class="image">

      @if (showDelete && !readonly) {
        <app-button-icon iconName="delete"
                         class="red remove-image"
                         (click)="removeImage(i)" />
      }
    </div>
  }
}
